// @flow
import { createRef, useState } from "react";
import {
  Heading,
  QuestionWrapper,
  RadioButtons,
  type RadioButtonsOptions,
} from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const validate = validatePresence("customerIntent", "Please select an option");

type CustomerIntentIncLettingValue = CustomerIntentValue | "LETTING";

export const options: RadioButtonsOptions<CustomerIntentIncLettingValue> = [
  {
    value: "ALREADY_ON_THE_MARKET",
    label: "Already on the market",
  },
  {
    value: "READY_TO_SELL",
    label: "Ready to sell",
  },
  {
    value: "THINKING_ABOUT_IT",
    label: "Thinking about selling",
  },
  {
    value: "LETTING",
    label: "Looking to let your property",
  },
  {
    value: "LOOKING_TO_BUY",
    label: "Looking to buy",
  },
  {
    value: "JUST_CURIOUS",
    label: "Just curious",
  },
];

type Props = {
  ...QuestionProps<"customerIntent">,
};

export const CustomerIntent = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: Props) => {
  const [customerIntent, setCustomerIntent] = useState(initialValue);

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <>
      <QuestionWrapper
        next={() => {
          next(customerIntent, validate);
        }}
        dataTest="where-in-your-home-move-are-you-question"
      >
        <BackButton />
        <Heading>Great, Nested is in your area! Are you…</Heading>
        <RadioButtons
          data-test="customer-intent-radios"
          errorMessage={validationErrors.customerIntent}
          hasErrors={!valid}
          name="where-in-your-home-move"
          onChange={setCustomerIntent}
          options={options}
          ref={ref}
          value={customerIntent}
        />
        <ActionButtons />
      </QuestionWrapper>
    </>
  );
};
